import React from "react";
import styles from "./winterMaintenceBar.module.scss";
import SideBarInner from "../../../shared/sideBarInner";
import SideBarControl from "../../sides/sideBarControl";
import TitleBarWrapper from "../../../shared/titleBarWrapper";
import FirstTitle from "../../../shared/items/static/firstTitle";
import WinterMaintenceTitleBar from "../reports/WinterMaintenceTitleBar";
import WinterMaintenceTools from "../../Contents/WinterMaintenceContent/WinterMaintenceTools";

const WinterMaintenceBar = (props) => {
  return (
    <div className={styles.sideBarsWrapper}>
      <SideBarControl TitleClosed={<WinterMaintenceTitleBar />}>
        <div className={styles.routesBar}>
          <SideBarInner>
            <TitleBarWrapper>
              <FirstTitle>Зимнее содержание</FirstTitle>
            </TitleBarWrapper>
          </SideBarInner>

          <WinterMaintenceTools />
        </div>
      </SideBarControl>
    </div>
  );
};

export default React.memo(WinterMaintenceBar);
